import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {Logger, LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {GameAssets} from "./GameAssets";
import {GameSounds} from "./sound/GameSounds";
import {Background} from "./view/Background";
import {CommonWinPresentation} from "./presentation/flowstate/CommonWinPresentation";
import {NormalBetPresentation} from "./presentation/flowstate/NormalBetPresentation";
import {NormalResultPresentation} from "./presentation/flowstate/NormalResultPresentation";
import {NormalIdlePresentation} from "./presentation/flowstate/NormalIdlePresentation";
import {BonusIdlePresentation} from "./presentation/flowstate/BonusIdlePresentation";
import {HOTBData, HOTBGameData, ISymbolValues} from "./server/HOTBData";
import {ExtendedGameModel} from "./server/ExtendedGameModel";
import {ReelArea} from "./reels/ReelArea";
import {AvalancheIdlePresentation} from "./presentation/flowstate/AvalancheIdlePresentation";
import {AvalancheResultPresentation} from "./presentation/flowstate/AvalancheResultPresentation";
import {AvalancheBetPresentation} from "./presentation/flowstate/AvalancheBetPresentation";
import {ExtendedGameMode} from "./server/ExtendedGameMode";
import {FSIntroView} from "./view/FSIntroView";
import {FSOutroView} from "./view/FSOutroView";
import {TotalWinView} from "./view/TotalWinView";
import {WinCapView} from "./view/WinCapView";
import {TopReelView} from "./view/specialReels/topReel/TopReelView";
import {LeftReelView} from "./view/specialReels/sideReel/LeftReelView";
import {RightReelView} from "./view/specialReels/sideReel/RightReelView";
import {MultiBoard} from "./view/MultiBoard";
import {WaysBoard} from "./view/WaysBoard";
import {Speedster} from "../core/debug/Speedster";
import {AnimUtils} from "./utils/AnimUtils";
import {BigWinView} from "./view/BigWinView";
import {Foreground} from "./view/Foreground";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {EachSymWinView} from "./view/EachSymWinView";
import {SymbolsList} from "./reels/GameSymbol";
import {GameConfig} from "./GameConfig";
import {PreBigWinView} from "./view/preBigWinView";
/*import {SpineViewUtils} from "./utils/SpineViewUtils";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";*/
import {PickAndClickPresentation} from "./presentation/flowstate/PickAndClickPresentation";
import {PickAndClickView} from "./view/PickAndClickView";
import {SatanSpinView} from "./view/SatanSpinView";
import {XBetChangeHandler} from "./view/XBetChangeHandler";
import {GameUtils} from "./utils/GameUtils";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {GameOverlay} from "./view/GameOverlay";
import {TopReelGlassOverlay} from "./view/TopReelGlassOverlay";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";

export class HOTB extends SlotGame {
    public static model: ExtendedGameModel;
    public static assetLoader: AssetLoader;
    public static soundPlayer: GameSounds;
    public static gameBackground: Background;
    public static gameOverlay: GameOverlay;
    public static gameFlowController: GameFlowController;
    public static reelArea: ReelArea;
    public static gameForeground: Foreground;
    public static waysCounter: WaysBoard;
    public static gameMultiplier: MultiBoard;
    public static topReel: TopReelView;
    public static glassOverlay: TopReelGlassOverlay;
    public static leftReel: LeftReelView;
    public static rightReel: RightReelView;
    public static fsIntro: FSIntroView;
    public static fsOutro: FSOutroView;
    public static winCap: WinCapView;
    public static eachSymWinView: EachSymWinView;
    public static totalWinView: TotalWinView;
    public static pickAndClickView: PickAndClickView;
    public static preBigWinView: PreBigWinView;
    public static bigWinView: BigWinView;
    public static satanSpinView: SatanSpinView;
    public static xBetChangeHandler: XBetChangeHandler;
    public static speedSter: Speedster;
    private skinner:Skinner;
    constructor() {
        super();
        const validSkins:string[] = [
            "sweep"
        ]
        this.skinner = new Skinner(validSkins);
    }

    private handleSweepInit(){
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
            })
        }
    }

    private handleSweepGetReady() : Promise<any>{
        if (this.skinner.skinId != undefined) {
            const replaceMap:Map<string, string> = new Map();
            //Bonus
            replaceMap.set("BOOSTED_BET_1", "BOOSTED_BET_1.png");
            replaceMap.set("BOOSTED_BET_2", "BOOSTED_BET_2.png");
            replaceMap.set("pageImage_6", "pageImage_6.png");
            replaceMap.set("pageImage_7", "pageImage_7.png");
            return this.skinner.loadSkin(replaceMap);
        }
        return Promise.resolve();
    }

    private static isInBonusGame(): boolean {
        const hotbData: HOTBData = HOTB.model.data,
            mode: ExtendedGameMode = hotbData.mode,
            nextMode: ExtendedGameMode = hotbData.nextMode;

        let flag: boolean = false;

        if ((mode === ExtendedGameMode.NORMAL || mode === ExtendedGameMode.NORMAL_AVALANCHE) && (nextMode === ExtendedGameMode.FREESPIN || nextMode === ExtendedGameMode.FREESPIN_SUPER)) {
            flag = true;
        } else if ((mode === ExtendedGameMode.FREESPIN || mode === ExtendedGameMode.FREESPIN_AVALANCHE) && (nextMode === ExtendedGameMode.FREESPIN || nextMode === ExtendedGameMode.FREESPIN_AVALANCHE || nextMode === ExtendedGameMode.FREESPIN_SUPER)) {
            flag = true;
        } else if ((mode === ExtendedGameMode.FREESPIN_SUPER || mode === ExtendedGameMode.FREESPIN_SUPER_AVALANCHE) && (nextMode === ExtendedGameMode.FREESPIN_SUPER || nextMode === ExtendedGameMode.FREESPIN_SUPER_AVALANCHE)) {
            flag = true;
        } else if (mode === ExtendedGameMode.CAPWIN_GAME && (nextMode === ExtendedGameMode.FREESPIN || nextMode === ExtendedGameMode.FREESPIN_SUPER)) {
            flag = true;
        }

        return flag;
    }

    getNoWinGameData(): any {
        return {
            "reels": [["M1", "L1", "L5", "M3"], ["L2", "M4", "M5", "M2"], ["L5", "M1", "M4", "L4"], ["L3", "L4", "L4", "L3"], ["L4", "M2", "M3", "M3"]],
            "evaluatedArea": [["M1", "L1", "L5", "M3"], ["L2", "M4", "M5", "M2"], ["L5", "M1", "M4", "L4"], ["L3", "L4", "L4", "L3"], ["L4", "M2", "M3", "M3"]],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "spinRoundWin": 0,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "symbolSizes": [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
            "reelTop": ["D", "D", "D", "D", "D"],
            "reelLeft": ["BLANK", "BLANK", "BLANK", "BLANK"],
            "reelRight": ["BLANK", "X4", "BLANK", "BLANK"],
            "freespinTriggeredThisSpin": false,
            "featureBuyName": "NORMAL_PLAY",
            "wasFeatureBuy": false,
            "boostedBetPlayed": false,
            "deleteMap": [[false, false, false, false], [false, false, false, false], [false, false, false, false], [false, false, false, false], [false, false, false, false]],
            "symbolsAfterAvalanche": [["BLANK", "BLANK", "BLANK", "BLANK"], ["BLANK", "BLANK", "BLANK", "BLANK"], ["BLANK", "BLANK", "BLANK", "BLANK"], ["BLANK", "BLANK", "BLANK", "BLANK"], ["BLANK", "BLANK", "BLANK", "BLANK"]],
            "reelTopAfterAvalanche": ["BLANK", "BLANK", "BLANK", "BLANK", "BLANK"],
            "brokeTheBank": false,
            "gameMultiplierAfter": 1,
            "gameMultiplierBefore": 1,
            "reelLeftNew": ["BLANK", "BLANK", "BLANK", "BLANK"],
            "reelRightNew": ["BLANK", "X4", "BLANK", "BLANK"],
            "sideReelInfo": {"reelLeft": [], "reelRight": []},
            "nudgeMultipliersCurrent": [0, 0, 0, 0, 0],
            "nudgeMultipliersNext": [0, 0, 0, 0, 0],
            "xBombList": [],
            "waysWonTotalRound": 0,
            "fsUpgradeToSuper": false,
            "capSymbolList": [],
            "symbolsAfterAvalanchePrevSpin": [["BLANK", "BLANK", "BLANK", "BLANK"], ["BLANK", "BLANK", "BLANK", "BLANK"], ["BLANK", "BLANK", "BLANK", "BLANK"], ["BLANK", "BLANK", "BLANK", "BLANK"], ["BLANK", "BLANK", "BLANK", "BLANK"]],
            "symbolMultipliers": [[0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0]],
            "nudgeMultipliersBeforeSplit": [0, 0, 0, 0, 0]
        };
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            HOTB.model = new ExtendedGameModel(SlotGame.apiPlugin, true);
            HOTB.gameFlowController = new GameFlowController(SlotGame.apiPlugin, HOTB.model);
            HOTB.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            HOTB.model.events?.on(GameModelEvent.GAME, (data: HOTBGameData) => {
                console.log(data);
            });

            const normalIdle: NormalIdlePresentation = new NormalIdlePresentation(),
                normalBet: NormalBetPresentation = new NormalBetPresentation(),
                normalResult: NormalResultPresentation = new NormalResultPresentation(),

                avalancheIdle: AvalancheIdlePresentation = new AvalancheIdlePresentation(),
                avalancheBet: AvalancheBetPresentation = new AvalancheBetPresentation(),
                avalancheResult: AvalancheResultPresentation = new AvalancheResultPresentation(),

                bonusIdle: BonusIdlePresentation = new BonusIdlePresentation(),

                commonWinPres: CommonWinPresentation = new CommonWinPresentation(),

                pickAndClick: PickAndClickPresentation = new PickAndClickPresentation();

            HOTB.gameFlowController.addGameModeFlowStatePresentationMap(ExtendedGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, normalIdle],
                [FlowState.BET, normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, commonWinPres]
            ]));

            HOTB.gameFlowController.addGameModeFlowStatePresentationMap(ExtendedGameMode.NORMAL_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, avalancheIdle],
                [FlowState.BET, avalancheBet],
                [FlowState.RESULT, avalancheResult],
                [FlowState.WIN, commonWinPres]
            ]));

            HOTB.gameFlowController.addGameModeFlowStatePresentationMap(ExtendedGameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, bonusIdle],
                [FlowState.BET, normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, commonWinPres]
            ]));

            HOTB.gameFlowController.addGameModeFlowStatePresentationMap(ExtendedGameMode.FREESPIN_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, avalancheIdle],
                [FlowState.BET, avalancheBet],
                [FlowState.RESULT, avalancheResult],
                [FlowState.WIN, commonWinPres]
            ]));

            HOTB.gameFlowController.addGameModeFlowStatePresentationMap(ExtendedGameMode.FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, bonusIdle],
                [FlowState.BET, normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, commonWinPres]
            ]));

            HOTB.gameFlowController.addGameModeFlowStatePresentationMap(ExtendedGameMode.FREESPIN_SUPER_AVALANCHE, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, avalancheIdle],
                [FlowState.BET, avalancheBet],
                [FlowState.RESULT, avalancheResult],
                [FlowState.WIN, commonWinPres]
            ]));

            HOTB.gameFlowController.addGameModeFlowStatePresentationMap(ExtendedGameMode.CAPWIN_GAME, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, pickAndClick],
                [FlowState.RESULT, pickAndClick],
                [FlowState.WIN, commonWinPres]
            ]));

            this.handleSweepInit();
            return value;
        });
    }

    //Show intro and load game assets
    public getReady(): Promise<NolimitPlugin> {
        return super.getReady().then((value: NolimitPlugin) => {

            const fontLoader: FontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            AssetsConfig.addToAssetsConfig(GameAssets.RESOURCES_GROUPS);
            HOTB.assetLoader = new AssetLoader(HOTB.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises: Promise<[boolean, any, any]> = Promise.all([fontLoader.load(), HOTB.assetLoader.load(ResourcesGroupName.MAIN), this.handleSweepGetReady()]);

            return promises.then((values: any) => {
                const gameModel: ExtendedGameModel = HOTB.model;

                if (gameModel.isRestore) {
                    gameModel.updateSymbolSizesAfterCollapse();
                }
                this.createViewsAndComponents();

                HOTB.topReel.onGameLoad();
                HOTB.leftReel.onGameLoad();
                HOTB.rightReel.onGameLoad();
                HOTB.gameMultiplier.onGameLoad();
                HOTB.waysCounter.updateFinalWaysCounter();

                return value;
            });
        });
    }

    //Game assets loaded, waiting for user to start game.
    public getReadyToStart(): Promise<NolimitPlugin> {
        return super.getReadyToStart().then((value: NolimitPlugin) => {
            const gameModel: ExtendedGameModel = HOTB.model,
                nextMode: ExtendedGameMode = gameModel.data.nextMode;

            HOTB.soundPlayer.playLoopEffect(GameSounds.GAME_SPLASH_LOOP);

            if (gameModel.isRestore) {
                this.updateScattersCount();

                const activeBetFeature: BetFeature | undefined = GameUtils.getActiveBetFeature();
                GameConfig.PREV_XBET_TYPE = activeBetFeature?.name;

                if (GameConfig.PREV_XBET_TYPE === "SATAN_SPINS") {
                    HOTB.gameBackground.toggleSatanBackground(true);
                }
            } else {
                if (!(HOTB.apiPlugin.isReplay)) {
                    HOTB.gameForeground.showStaticDoors(nextMode, true);
                }
            }

            return value;
        });
    }

    //User has pressed continue and the game starts.
    public start(): Promise<NolimitPlugin> {
        /*// @ts-ignore
        window.parent["game"] = HOTB;*/
        return super.start().then((value: NolimitPlugin) => {
            if (HOTB.isInBonusGame()) {
                GameUtils.toggleSymbols(false);
                HOTB.fsIntro.showIntro(() => {
                    HOTB.gameFlowController.start();
                });
            } else {
                HOTB.gameFlowController.start();
            }
            HOTB.soundPlayer.playSound(GameSounds.CONTINUE_BUTTON);
            HOTB.soundPlayer.stopLoopEffect(GameSounds.GAME_SPLASH_LOOP);

            const gameModel: ExtendedGameModel = HOTB.model,
                hotbData: HOTBData = gameModel.data,
                currMode: string = hotbData.mode,
                nextMode: string = hotbData.nextMode;

            HOTB.gameBackground.playIdle(nextMode);

            if (gameModel.isRestore) {
                if (GameUtils.isSatanSpin()) {
                    HOTB.soundPlayer.switchMusic(currMode, 0);
                    if (nextMode === ExtendedGameMode.NORMAL_AVALANCHE) {
                        HOTB.soundPlayer.playSatanSpinSounds();
                    }
                } else if (hotbData.nextMode === ExtendedGameMode.CAPWIN_GAME) {
                    HOTB.soundPlayer.switchMusic(currMode, 0);
                    if (GameConfig.PREV_XBET_TYPE === ExtendedGameMode.CAPWIN_GAME) {
                        HOTB.gameOverlay.toggleTrimmedOverlay(true);
                    }
                } else if (nextMode === ExtendedGameMode.NORMAL_AVALANCHE) {
                    HOTB.soundPlayer.switchMusic(currMode);
                }

                if (!currMode.includes(ExtendedGameMode.NORMAL)) {
                    HOTB.model.isPlayingBonusSpins = true;
                }
            } else {
                HOTB.soundPlayer.switchMusic(currMode);
                HOTB.soundPlayer.playSound(GameSounds.GAME_INTRO);
                HOTB.gameForeground.onGameStart();
            }

            /*const stageLayer: any = AnimUtils.getStageContainer();
            stageLayer.parent.children[2].children[0].children[0].children[2].children[5].scale.set(0.5);*/

            return value;
        });
    }

    public getPaytable(): Promise<string> {
        const templateLoader: TemplateLoader = new TemplateLoader(SlotGame.apiPlugin.resources.getStaticRoot()),
            data1: { boostedBetAllowed: boolean, replaceWincapInfo: boolean } = {
                boostedBetAllowed: HOTB.apiPlugin.gameClientConfiguration.boostedBetAllowed,
                replaceWincapInfo: HOTB.apiPlugin.gameClientConfiguration.replaceWincapInfo
            };

        templateLoader.add({
            name: "Paytable",
            url: "nolimit/screens/paytable.mustache"
        });

        const data = {
            skinPath: "screens/images/"
        };
        if (this.skinner.skinId != undefined) {
            data.skinPath = `../resources/images/${this.skinner.skinId}/`;
        }

        let symbolDataValueData: ISymbolValues = {
            "L1": {3: 10, 4: 20, 5: 40},
            "L2": {3: 8, 4: 16, 5: 32},
            "L3": {3: 7, 4: 14, 5: 30},
            "L4": {3: 6, 4: 12, 5: 25},
            "L5": {3: 5, 4: 10, 5: 20},
            "M1": {3: 60, 4: 80, 5: 100},
            "M2": {3: 50, 4: 60, 5: 80},
            "M3": {3: 40, 4: 50, 5: 70},
            "M4": {3: 30, 4: 40, 5: 60},
            "M5": {3: 20, 4: 30, 5: 50}
        };

        if (HOTB.model.initData.symbolValues) {
            symbolDataValueData = HOTB.model.initData.symbolValues;

            Logger.logDev("Using symbolValues from INIT data");
        } else {
            Logger.logDev("Using default symbolValues");
        }

        return templateLoader.load().then((assets: TemplateAsset[]) => {
            for (let asset of assets) {
                if (asset.name == "Paytable" && asset.loadedData) {
                    asset.loadedData = asset.loadedData.replace(/{{skinPath}}/g, data.skinPath);
                    for (let key in symbolDataValueData) {
                        asset.loadedData = asset.loadedData.replace(`{{${key}}}`, this.getSymbolString(key, symbolDataValueData[key]));
                    }
                    return asset.loadedData;
                }
            }
            throw new Error("SlotGame could not load Paytable");
        }).then((value: string) => {
            return HOTB.apiPlugin.translations.render(value, data1);
        });
    }

    private updateScattersCount(): void {
        GameConfig.scatterPositions = ArrayHelper.initArrayWithValues(GameConfig.totalReels, () => -1);
        GameConfig.hasAnticipation = ArrayHelper.initArrayWithValues(GameConfig.totalReels, () => false);

        const reelsData: string[][] = HOTB.model.data.reels;

        reelsData.forEach((reel: string[], reelId: number): void => {
            reel.forEach((sym: string, symId: number): void => {
                if (sym === SymbolsList.S1) {
                    GameConfig.scatterPositions[reelId] = symId;
                    GameConfig.TOTAL_SCATTER_COUNT++;
                    GameConfig.scatterLandedInReels[reelId] = true;
                }
            });
        });

        if (GameConfig.scatterPositions.filter(item => item > -1).length > 1) {
            for (let reelId: number = 0; reelId < GameConfig.scatterPositions.length; reelId++) {
                GameConfig.hasAnticipation[reelId] = GameConfig.scatterPositions[reelId] === -1;
            }
        }
    }

    private getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
        let symbol: string;

        if (key === "W") {
            symbol = `<div class="symbol">
            <img alt="" src="{{gamePath}}game-history/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
            </div>
            </div>`;
        } else {
            symbol = `<div class="symbol">
            <img alt="" src="{{gamePath}}game-history/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>`;
        }
        return symbol;
    }

    /*public static showSpineUtils(): void {
        if (NolimitConfig.isDevMode) {
            SpineViewUtils.init(GameAssets.RESOURCES_GROUPS.main, HOTB.assetLoader);
        }
    }*/

    private createViewsAndComponents(): void {
        //Non views
        HOTB.soundPlayer = new GameSounds();

        //Static views
        HOTB.gameBackground = new Background();
        HOTB.gameOverlay = new GameOverlay();
        HOTB.reelArea = new ReelArea();
        HOTB.gameForeground = new Foreground();
        HOTB.waysCounter = new WaysBoard();
        HOTB.gameMultiplier = new MultiBoard();
        HOTB.topReel = new TopReelView();
        HOTB.glassOverlay = new TopReelGlassOverlay();
        HOTB.leftReel = new LeftReelView();
        HOTB.rightReel = new RightReelView();
        HOTB.fsIntro = new FSIntroView();
        HOTB.fsOutro = new FSOutroView();
        HOTB.winCap = new WinCapView();
        HOTB.eachSymWinView = new EachSymWinView();
        HOTB.totalWinView = new TotalWinView();
        HOTB.pickAndClickView = new PickAndClickView();
        HOTB.preBigWinView = new PreBigWinView();
        HOTB.bigWinView = new BigWinView();
        HOTB.satanSpinView = new SatanSpinView();
        HOTB.xBetChangeHandler = new XBetChangeHandler();
        HOTB.speedSter = new Speedster();

        NolimitApplication.addLayerAt(HOTB.speedSter.name, HOTB.speedSter, 0);
        NolimitApplication.addLayerAt(HOTB.bigWinView.name, HOTB.bigWinView, 0);
        NolimitApplication.addLayerAt(HOTB.preBigWinView.name, HOTB.preBigWinView, 0);
        NolimitApplication.addLayerAt(HOTB.totalWinView.name, HOTB.totalWinView, 0);
        NolimitApplication.addLayerAt(HOTB.eachSymWinView.name, HOTB.eachSymWinView, 0);
        NolimitApplication.addLayerAt(HOTB.fsIntro.name, HOTB.fsIntro, 0);
        NolimitApplication.addLayerAt(HOTB.fsOutro.name, HOTB.fsOutro, 0);
        NolimitApplication.addLayerAt(HOTB.satanSpinView.name, HOTB.satanSpinView, 0);
        NolimitApplication.addLayerAt(HOTB.winCap.name, HOTB.winCap, 0);
        NolimitApplication.addLayerAt(HOTB.rightReel.name, HOTB.rightReel, 0);
        NolimitApplication.addLayerAt(HOTB.leftReel.name, HOTB.leftReel, 0);
        NolimitApplication.addLayerAt(HOTB.glassOverlay.name, HOTB.glassOverlay, 0);
        NolimitApplication.addLayerAt(HOTB.gameMultiplier.name, HOTB.gameMultiplier, 0);
        NolimitApplication.addLayerAt(HOTB.waysCounter.name, HOTB.waysCounter, 0);
        NolimitApplication.addLayerAt(HOTB.topReel.name, HOTB.topReel, 0);
        NolimitApplication.addLayerAt(HOTB.gameForeground.name, HOTB.gameForeground, 0);
        NolimitApplication.addLayerAt(HOTB.pickAndClickView.name, HOTB.pickAndClickView, 0);
        NolimitApplication.addLayerAt(HOTB.reelArea.name, HOTB.reelArea, 0);
        NolimitApplication.addLayerAt(HOTB.gameOverlay.name, HOTB.gameOverlay, 0);
        NolimitApplication.addLayerAt(HOTB.gameBackground.name, HOTB.gameBackground, 0);

        AnimUtils.screenShakeTargets.push({
            target: AnimUtils.getStageContainer(),
            ogPos: (AnimUtils.getStageContainer()).position.clone()
        });
    }
}